import styles from '../ProductQuiz.module.scss';
import React, { useEffect } from 'react';
import { Button, Flex, Text } from '@mantine/core';
import { useProductQuiz } from '../ProductQuizContext';
import { QuestionTitle } from './QuestionTitle';
import { ReactComponent as IndoorsIcon } from '../../../assets/images/icons/icon_indoors.svg';
import { ReactComponent as OutdoorsIcon } from '../../../assets/images/icons/icon_outdoors.svg';
import { QuestionNextButton } from './QuestionNextButton';
import { quizQuestionPage } from '../../../lib/analytics/events';
import { useTranslation } from 'react-i18next';

const SPEND_TIME = [
  {
    name: 'Indoors',
    icon: (className: string) => <IndoorsIcon className={className} />,
  },
  {
    name: 'Outdoors',
    icon: (className: string) => <OutdoorsIcon className={className} />,
  },
];

export const QuestionSpendTime: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    quizQuestionPage.quizPetTimeSpentPageEntered();
  }, []);

  const { quizAnswers, setQuizAnswers } = useProductQuiz();

  const items = SPEND_TIME.map(({ name, icon }) => (
    <Button
      key={name}
      unstyled
      data-active={quizAnswers.spendTime.has(name) || undefined}
      className={styles.quizButton}
      onClick={() => {
        if (quizAnswers.spendTime.has(name)) {
          const updatedSpendTime = new Set(quizAnswers.spendTime);
          updatedSpendTime.delete(name);
          setQuizAnswers({ ...quizAnswers, spendTime: updatedSpendTime });
        } else {
          setQuizAnswers({ ...quizAnswers, spendTime: new Set(quizAnswers.spendTime).add(name) });
        }
      }}
      sx={{
        borderRadius: 16,
        flex: 1,
        width: '100%',
      }}
    >
      <Flex direction="column" align="center" justify="flex-start" gap="md" py={32} px={16}>
        {icon(quizAnswers.spendTime.has(name) ? styles.iconYellow : styles.iconWhite)}
        <Text
          sx={(theme) => ({
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '120%',
            letterSpacing: '-0.16px',
            color: quizAnswers.spendTime.has(name) ? theme.colors['fi-yellow'] : 'white',
          })}
        >
          {name}
        </Text>
      </Flex>
    </Button>
  ));

  return (
    <>
      <QuestionTitle subtitle={t('select_all_that_apply')}>
        {t('where_does_name_spend_time', { name: quizAnswers.petName })}
      </QuestionTitle>
      <Flex w="100%" p="md" gap={8}>
        {items}
      </Flex>
      <QuestionNextButton
        showOnDesktop={true}
        isDisabled={quizAnswers.spendTime.size === 0}
        event={() => quizQuestionPage.quizPetTimeSpentNext(Array.from(quizAnswers.spendTime).sort().join(', '))}
      />
    </>
  );
};
